<template>
	<div class="genre-box">
		<!--品类-->
		<div style="text-align: left;">
			<el-steps :active="$store.state.active" finish-status="success" align-center>
				<el-step title="选择企业码标和品类类目" style="width: 50%;"></el-step>
				<el-step title="填写码标信息" style="width: 50%;"></el-step>
				<el-step title="解析设置"></el-step>
			</el-steps>
		</div>
		<router-view/>
      
	</div>
</template>

<script>
	export default {
		data() {
			return {
				currentTabComponent: 'succeed',
				tabPosition: 'left',
				typeData: {
					one: 0,
					two: 1,
					three: 1

				},
				excursion: 0,
				active: 0,
				Thecard: {
					library: [{
							value: '',
							id: '',
						}

					],

				},

				Arrdata: []

			};
		}
	};
</script>

<style lang="scss">
	.is-text.el-step__icon {
		text-align: center\0;
		/*ie9*/
		line-height: 18px\9\0;
		/*ie9*/
	}
	/*.labelIcon{
	width: 200px;
	height: 200px;
	display: inline-block;
	border: solid red 1px;

}*/
	/*.el-tabs__item{

		height: auto !important;
	}*/
	
	.type-box {
		margin-top: 100px;
	}
	
	.genre-box {
		padding: 50px;
	}
	
	.box-card {
		width: 260px;
		margin-right: 20px;
		.clearfix {
			text-align: left;
			span {
				font-size: 16px;
				display: inline-block;
				/*width: 100%;*/
				text-align: left;
			}
		}
		.text {
			/*border: solid red 1px;*/
			padding: 12px 0;
			/*height: 400px;*/
			/*overflow: hidden;*/
			/*overflow-y: scroll;*/
			/*transition: border-color .2s, background-color .2s, color .2s;*/
			color: #666;
			border-bottom: 1px solid #ebeef5;
			font-size: 14px;
			cursor: pointer;
			&:hover {
				background-color: #f2f2f2;
			}
		}
		.item {
			background-color: #f2f2f2;
		}
	}
	
	.roll {
		/*border: red solid 1px;*/
		width: 70%;
		padding: 0 45px;
		/*margin-left: 30px;*/
		margin-top: 20px;
		/*padding-top: 80px;*/
		position: relative;
		/*height: 346px;*/
		float: left;
		overflow: hidden;
		.tired-box {
			width: 100%;
			overflow: hidden;
			overflow-x: scroll;
			display: inline-block;
			/*border: solid 1px rosybrown;*/
			.Kaku {
				/*border: solid red 1px;*/
				padding: 20px 0;
				/*width: 1400px;*/
				width: auto;
				/*width: 100%;*/
				transition: .1s;
			}
		}
		.rslide {
			top: 40%;
			right: 0;
			font-size: 40px;
			position: absolute;
		}
		.lslide {
			top: 40%;
			left: 0;
			font-size: 40px;
			position: absolute;
		}
	}
	
	.basics-box {
		width: 100px;
		text-align: left;
		position: relative;
		border-right: solid red 1px;
		.describe-box {
			cursor: pointer;
			margin: 12px 0;
			display: inline-block;
			text-align: center;
			.icon {
				width: 40px;
				height: 40px;
				border: solid 15px #f7f6f6;
			}
			.tit {
				font-size: 14px;
				color: #7c7d80;
				margin-top: 8px;
			}
		}
		.sign {
			white-space: nowrap;
			/*content:'';*/
			font-size: 20px;
			position: absolute;
			color: red;
			/*vertical-align: bottom;*/
			padding: 0;
			/*color: #2C3E50;*/
			border-right: solid red 1px;
			right: 0px;
			width: 13px;
			line-height: 300%;
			/*height: 20px;*/
			display: inline-block;
			top: 0;
		}
	}
	
	.left-box {}
	
	.Genhead {
		.f-fl {
			text-align: left;
			.item {
				/*border: solid red 1px;*/
				.tit {
					font-weight: 500;
					display: inline-block;
					font-size: 18px;
					color: #2C3E50;
				}
				.context {
					display: inline-block;
					color: #8C939D;
					font-size: 16px;
				}
			}
		}
	}
</style>